var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-method" },
    [
      _vm.showTrialEndModal
        ? _c("TrialEndConfirmationModal", {
            on: { confirm: _vm.confirmTrialEnd, cancel: _vm.cancelTrialEnd },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "payment-method__header" }, [
        _c("div", { staticClass: "payment-method__title" }, [
          _vm._v(_vm._s(_vm.$t("billing.paymentMethodAndInvoiceAddress"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "payment-method__content" }, [
        _c("div", { ref: "creditCard", staticClass: "payment-card" }, [
          _c("div", { staticClass: "payment-card__header" }, [
            _c("div", { staticClass: "header-content" }, [
              _c("div", { staticClass: "payment-card__title" }, [
                _vm._v(_vm._s(_vm.$t("billing.paymentMethod"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "iyzico-brand" },
                [_c("IyzicoPay", { staticClass: "iyzico-logo" })],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.isEditingCreditCard || _vm.isSavedCreditCard
            ? _c("div", { staticClass: "payment-card__content" }, [
                !_vm.isEditingCreditCard
                  ? _c(
                      "div",
                      { staticClass: "payment-card__info" },
                      [
                        _c(
                          "div",
                          { staticClass: "card-info-left" },
                          [
                            _c("DynamicSvg", {
                              staticClass: "payment-card__icon",
                              attrs: {
                                name: _vm.formatCardType(
                                  _vm.billingDetail.cardAssociation
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "payment-card__details" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "payment-card__number" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCardNumber(
                                          _vm.billingDetail.binNumber
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "payment-card__meta" },
                                  [
                                    _c("span", { staticClass: "card-type" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatCardType(
                                            _vm.billingDetail.cardAssociation
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "SupsisButton",
                          {
                            attrs: { ghost: "", classNames: "action-button" },
                            on: { click: _vm.toggleCreditCardEditMode },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("calendar.change")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "credit-card-edit" }, [
                      _c(
                        "div",
                        {
                          staticClass: "address-item full-width",
                          class: {
                            "has-error": _vm.creditCardErrors.cardHolder,
                          },
                        },
                        [
                          _c(
                            "a-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("billing.cardHolderName"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("a-icon", { attrs: { type: "user" } }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("a-input", {
                            staticClass: "edit-input large-font",
                            attrs: {
                              autocomplete: "cc-name",
                              name: "cardholderName",
                              id: "cardholderName",
                              "data-field": "cardHolder",
                              placeholder: _vm.$t("billing.cardHolderName"),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.handleCreditCardInput("cardHolder")
                              },
                            },
                            model: {
                              value: _vm.editableCreditCard.cardHolder,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editableCreditCard,
                                  "cardHolder",
                                  $$v
                                )
                              },
                              expression: "editableCreditCard.cardHolder",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "credit-card-columns" }, [
                        _c(
                          "div",
                          {
                            staticClass: "address-item",
                            class: {
                              "has-error": _vm.creditCardErrors.cardNumber,
                            },
                          },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.cardNumber"))),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", {
                                  attrs: { type: "credit-card" },
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("a-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "#### #### #### ####",
                                  expression: "'#### #### #### ####'",
                                },
                              ],
                              staticClass: "edit-input large-font",
                              attrs: {
                                autocomplete: "cc-number",
                                name: "cardNumber",
                                id: "cardNumber",
                                inputmode: "numeric",
                                "data-field": "cardNumber",
                                placeholder: "**** **** **** ****",
                                type: "tel",
                              },
                              model: {
                                value: _vm.editableCreditCard.cardNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editableCreditCard,
                                    "cardNumber",
                                    $$v
                                  )
                                },
                                expression: "editableCreditCard.cardNumber",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "address-item small-input",
                            class: { "has-error": _vm.creditCardErrors.expiry },
                          },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.expireDate"))),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", { attrs: { type: "calendar" } }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("a-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "##/##",
                                  expression: "'##/##'",
                                },
                              ],
                              staticClass: "edit-input",
                              attrs: {
                                autocomplete: "cc-exp",
                                name: "ccExp",
                                id: "ccExp",
                                inputmode: "numeric",
                                pattern: "(0[1-9]|1[0-2])\\/?([0-9]{2})",
                                "data-field": "expiry",
                                placeholder: "MM/YY*",
                                type: "tel",
                              },
                              model: {
                                value: _vm.editableCreditCard.expiry,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editableCreditCard,
                                    "expiry",
                                    $$v
                                  )
                                },
                                expression: "editableCreditCard.expiry",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "address-item small-input",
                            class: { "has-error": _vm.creditCardErrors.cvc },
                          },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v("CVC"),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", {
                                  attrs: { type: "safety-certificate" },
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("a-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "###",
                                  expression: "'###'",
                                },
                              ],
                              staticClass: "edit-input",
                              attrs: {
                                autocomplete: "cc-csc",
                                name: "cvc",
                                id: "cvc",
                                inputmode: "numeric",
                                pattern: "\\d*",
                                "data-field": "cvc",
                                placeholder: "***",
                                type: "tel",
                                maxlength: "4",
                              },
                              model: {
                                value: _vm.editableCreditCard.cvc,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editableCreditCard, "cvc", $$v)
                                },
                                expression: "editableCreditCard.cvc",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "address-actions" },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                ghost: "",
                                classNames: "action-button",
                                disabled: _vm.isSavingCreditCard,
                              },
                              on: { click: _vm.cancelCreditCardEdit },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("billing.cancel")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                classNames: "action-button",
                                disabled: _vm.isSavingCreditCard,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.saveCreditCard.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm.isSavingCreditCard
                                ? _c("a-spin", {
                                    staticStyle: { "margin-right": "8px" },
                                    attrs: { size: "small" },
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("billing.save")) +
                                  "\n                        "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "payment-card__notice" },
                  [
                    _c("a-icon", { attrs: { type: "lock", theme: "filled" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("billing.cardInfoIsStoredSecurelyByIyzico")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
              ])
            : !_vm.isEditingCreditCard
            ? _c(
                "div",
                { staticClass: "empty-state" },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("credit_card_off"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("billing.notFoundSavedCard"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "", classNames: "action-button" },
                      on: { click: _vm.toggleCreditCardEditMode },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("settings.newAdd")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payment-card" }, [
          _c("div", { staticClass: "payment-card__header" }, [
            _c("div", { staticClass: "payment-card__title" }, [
              _vm._v(_vm._s(_vm.$t("billing.invoiceAddress"))),
            ]),
          ]),
          _vm._v(" "),
          _vm.isEditingBillingAddress || _vm.billingDetail.name
            ? _c("div", { staticClass: "payment-card__content" }, [
                !_vm.isEditingBillingAddress
                  ? _c("div", { staticClass: "address-info" }, [
                      _c("div", { staticClass: "address-columns" }, [
                        _c(
                          "div",
                          { staticClass: "address-item" },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.billingDetail.billingType ===
                                          "company"
                                          ? _vm.$t("billing.companyName")
                                          : _vm.$t("automation.nameSurname")
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", {
                                  attrs: {
                                    type:
                                      _vm.billingDetail.billingType ===
                                      "company"
                                        ? "shop"
                                        : "user",
                                  },
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "address-value" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.billingDetail.name) +
                                    "\n                                "
                                ),
                                _vm.billingDetail.billingType !== "company"
                                  ? [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.billingDetail.surname) +
                                          "\n                                "
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "address-item" },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("calendar.emailAddress"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", { attrs: { type: "mail" } }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "address-value" }, [
                              _vm._v(_vm._s(_vm.billingDetail.email)),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "address-columns" }, [
                        _vm.billingDetail.billingType !== "company"
                          ? _c(
                              "div",
                              { staticClass: "address-item" },
                              [
                                _c(
                                  "a-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("probel.identityNumber"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-icon", { attrs: { type: "audit" } }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "address-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.billingDetail.identityNumber)
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.billingDetail.billingType === "company"
                          ? _c(
                              "div",
                              { staticClass: "address-item" },
                              [
                                _c(
                                  "a-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("billing.taxOffice"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-icon", { attrs: { type: "audit" } }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "address-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.billingDetail.taxOffice ||
                                        "Belirtilmemiş"
                                    )
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.billingDetail.billingType === "company"
                          ? _c(
                              "div",
                              { staticClass: "address-item" },
                              [
                                _c(
                                  "a-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("billing.taxNumber"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-icon", { attrs: { type: "number" } }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "address-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.billingDetail.taxNumber ||
                                        "Belirtilmemiş"
                                    )
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "address-columns" }, [
                        _c(
                          "div",
                          { staticClass: "address-item" },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("billing.billingCountry"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", { attrs: { type: "global" } }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "address-value" }, [
                              _vm._v(_vm._s(_vm.billingDetail.billingCountry)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "address-item" },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.billingCity"))),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", {
                                  attrs: { type: "environment" },
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "address-value" }, [
                              _vm._v(_vm._s(_vm.billingDetail.billingCity)),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "address-item full-width" },
                        [
                          _c(
                            "a-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(_vm._s(_vm.$t("message.address"))),
                              ]),
                              _vm._v(" "),
                              _c("a-icon", { attrs: { type: "home" } }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "address-value" }, [
                            _vm._v(_vm._s(_vm.billingDetail.billingAddress)),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "address-actions" },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                classNames: "action-button",
                              },
                              on: { click: _vm.toggleEditMode },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("billing.updateBillingInfo")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _c("div", { staticClass: "address-info" }, [
                      _c("div", { staticClass: "address-item full-width" }, [
                        _c(
                          "div",
                          { staticClass: "billing-type-container" },
                          [
                            _c("span", { staticClass: "billing-type-label" }, [
                              _vm._v("Fatura Türü:"),
                            ]),
                            _vm._v(" "),
                            _c("a-switch", {
                              staticClass: "billing-type-switch",
                              attrs: {
                                "checked-children": "Şirket",
                                "un-checked-children": "Bireysel",
                              },
                              model: {
                                value: _vm.editableBillingDetail.isCompany,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editableBillingDetail,
                                    "isCompany",
                                    $$v
                                  )
                                },
                                expression: "editableBillingDetail.isCompany",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "address-columns" }, [
                        _vm.editableBillingDetail.isCompany
                          ? _c(
                              "div",
                              {
                                staticClass: "address-item",
                                class: {
                                  "has-error": _vm.billingErrors.companyName,
                                },
                              },
                              [
                                _c(
                                  "a-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("billing.companyName"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-icon", { attrs: { type: "shop" } }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticClass: "edit-input",
                                  attrs: {
                                    "data-field": "companyName",
                                    placeholder: "Şirket Adı*",
                                    required: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.handleInput("companyName")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.editableBillingDetail.companyName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editableBillingDetail,
                                        "companyName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "editableBillingDetail.companyName",
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "address-item",
                                class: {
                                  "has-error": _vm.billingErrors.fullName,
                                },
                              },
                              [
                                _c(
                                  "a-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("automation.nameSurname"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-icon", { attrs: { type: "user" } }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticClass: "edit-input",
                                  attrs: {
                                    "data-field": "fullName",
                                    placeholder: "Ad Soyad*",
                                    required: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.handleInput("fullName")
                                    },
                                  },
                                  model: {
                                    value: _vm.editableBillingDetail.fullName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editableBillingDetail,
                                        "fullName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "editableBillingDetail.fullName",
                                  },
                                }),
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "address-item",
                            class: { "has-error": _vm.billingErrors.email },
                          },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("calendar.emailAddress"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", { attrs: { type: "mail" } }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("a-input", {
                              staticClass: "edit-input",
                              attrs: {
                                "data-field": "email",
                                type: "email",
                                placeholder: "E-Posta*",
                                required: "",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.handleInput("email")
                                },
                              },
                              model: {
                                value: _vm.editableBillingDetail.email,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editableBillingDetail,
                                    "email",
                                    $$v
                                  )
                                },
                                expression: "editableBillingDetail.email",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "address-columns" }, [
                        !_vm.editableBillingDetail.isCompany
                          ? _c(
                              "div",
                              {
                                staticClass: "address-item",
                                class: {
                                  "has-error": _vm.billingErrors.identityNumber,
                                },
                              },
                              [
                                _c(
                                  "a-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "auto.billingIdentityNumberTooltip"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-icon", { attrs: { type: "idcard" } }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticClass: "edit-input",
                                  attrs: {
                                    "data-field": "identityNumber",
                                    placeholder: "TC Kimlik Numarası*",
                                    required: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.handleInput("identityNumber")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.editableBillingDetail.identityNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editableBillingDetail,
                                        "identityNumber",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "editableBillingDetail.identityNumber",
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "address-item",
                                class: {
                                  "has-error": _vm.billingErrors.taxNumber,
                                },
                              },
                              [
                                _c(
                                  "a-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("billing.taxNumber"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-icon", { attrs: { type: "number" } }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticClass: "edit-input",
                                  attrs: {
                                    "data-field": "taxNumber",
                                    placeholder: "Vergi Numarası*",
                                    required: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.handleInput("taxNumber")
                                    },
                                  },
                                  model: {
                                    value: _vm.editableBillingDetail.taxNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editableBillingDetail,
                                        "taxNumber",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "editableBillingDetail.taxNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _vm.editableBillingDetail.isCompany
                          ? _c(
                              "div",
                              {
                                staticClass: "address-item",
                                class: {
                                  "has-error": _vm.billingErrors.taxOffice,
                                },
                              },
                              [
                                _c(
                                  "a-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("billing.taxOffice"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-icon", { attrs: { type: "audit" } }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticClass: "edit-input",
                                  attrs: {
                                    "data-field": "taxOffice",
                                    placeholder: "Vergi Dairesi*",
                                    required: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.handleInput("taxOffice")
                                    },
                                  },
                                  model: {
                                    value: _vm.editableBillingDetail.taxOffice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editableBillingDetail,
                                        "taxOffice",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "editableBillingDetail.taxOffice",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "address-columns" }, [
                        _c(
                          "div",
                          { staticClass: "address-item" },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("billing.billingCountry"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", { attrs: { type: "global" } }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("a-input", {
                              staticClass: "edit-input",
                              attrs: {
                                "data-field": "billingCountry",
                                placeholder: "Ülke*",
                                required: "",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.handleInput("billingCountry")
                                },
                              },
                              model: {
                                value: _vm.editableBillingDetail.billingCountry,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editableBillingDetail,
                                    "billingCountry",
                                    $$v
                                  )
                                },
                                expression:
                                  "editableBillingDetail.billingCountry",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "address-item" },
                          [
                            _c(
                              "a-tooltip",
                              { attrs: { placement: "top" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.billingCity"))),
                                ]),
                                _vm._v(" "),
                                _c("a-icon", {
                                  attrs: { type: "environment" },
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("a-input", {
                              staticClass: "edit-input",
                              attrs: {
                                "data-field": "billingCity",
                                placeholder: "Şehir*",
                                required: "",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.handleInput("billingCity")
                                },
                              },
                              model: {
                                value: _vm.editableBillingDetail.billingCity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editableBillingDetail,
                                    "billingCity",
                                    $$v
                                  )
                                },
                                expression: "editableBillingDetail.billingCity",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "address-item flex-start-item full-width",
                        },
                        [
                          _c(
                            "a-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(_vm._s(_vm.$t("message.address"))),
                              ]),
                              _vm._v(" "),
                              _c("a-icon", { attrs: { type: "home" } }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("a-textarea", {
                            staticClass: "edit-input",
                            attrs: {
                              "data-field": "billingAddress",
                              placeholder: "Tam Adres*",
                              rows: 3,
                              required: "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.handleInput("billingAddress")
                              },
                            },
                            model: {
                              value: _vm.editableBillingDetail.billingAddress,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editableBillingDetail,
                                  "billingAddress",
                                  $$v
                                )
                              },
                              expression:
                                "editableBillingDetail.billingAddress",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "address-actions" },
                        [
                          _c(
                            "SupsisButton",
                            {
                              attrs: { ghost: "", classNames: "action-button" },
                              on: { click: _vm.cancelEdit },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("billing.cancel")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              attrs: {
                                primary: "",
                                classNames: "action-button",
                              },
                              on: { click: _vm.saveBillingAddress },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("billing.save")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
              ])
            : _c(
                "div",
                { staticClass: "empty-state" },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("location_off"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("billing.notFoundSavedBillingAddress"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "", classNames: "action-button" },
                      on: { click: _vm.toggleEditMode },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("settings.newAdd")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }